import React from 'react';
import EspaceAdherent from '../components/EspaceAdherent';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <EspaceAdherent />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
